/* import __COLOCATED_TEMPLATE__ from './image-card.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Args {
  isInteractive: boolean;
  url?: string;
  imageAlt?: string;
}

interface Signature {
  Args: Args;
  Element: HTMLElement;
  Blocks: {
    default: [];
  };
}

const ImageCard = templateOnlyComponent<Signature>();
export default ImageCard;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Brands::ImageCard': typeof ImageCard;
  }
}
